import { j as c } from "../../jsx-runtime-B6kdoens.js";
import { c as i, f as n } from "../../create-component-CBAeEoQ6.js";
import { c as m } from "../../index-CROKJrb5.js";
const f = m({
  base: "cur-flex cur-flex-col"
}), u = i(
  "InteractiveList",
  n(
    ({ as: t, children: s, className: e, ...o }, r) => {
      const a = t || "div";
      return /* @__PURE__ */ c.jsx(
        a,
        {
          ref: r,
          className: f({ className: e }),
          role: "list",
          ...o,
          children: s
        }
      );
    }
  )
);
export {
  u as InteractiveList
};
//# sourceMappingURL=index.js.map
